import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import * as S from './legal/legalStyles';
import TermsContentKo from './legal/TermsContentKo';
import TermsContentEn from './legal/TermsContentEn';

const TermsOfServicePage: React.FC = () => {
  const { i18n } = useTranslation();
  const isKo = i18n.language.startsWith('ko');

  return (
    <div style={S.wrap}>
      <div style={S.langToggleBar}>
        <button
          style={S.langToggleBtn}
          onClick={() => i18n.changeLanguage(isKo ? 'en' : 'ko')}
        >
          {isKo ? 'View in English' : '한국어로 보기'}
        </button>
      </div>

      <h1 style={S.h1}>{isKo ? '이용약관' : 'Terms of Service'}</h1>
      <p style={S.dateLine}>
        {isKo
          ? '시행일: 2026년 1월 29일 | 최종 수정일: 2026년 1월 29일'
          : 'Effective Date: January 29, 2026 | Last Updated: January 29, 2026'}
      </p>

      {isKo ? <TermsContentKo /> : <TermsContentEn />}

      <div style={S.footerWrap}>
        <Link to="/" style={{ color: '#10b981', textDecoration: 'none' }}>
          {isKo ? '← 홈으로 돌아가기' : '← Back to Home'}
        </Link>
      </div>
    </div>
  );
};

export default TermsOfServicePage;
